module.exports = __webpack_public_path__ + "static/media/stanford_logo.cfd759c5.png";